import { useEffect } from 'react'

declare global {
  interface Window {
    fbq?: ((...args: unknown[]) => void) & {
      callMethod?: (...args: unknown[]) => void
      queue?: unknown[]
      push?: unknown
      loaded?: boolean
      version?: string
    }
    _fbq?: unknown
  }
}

const SCRIPT_ID = 'meta-pixel-script'
const SCRIPT_SRC = 'https://connect.facebook.net/en_US/fbevents.js'

/**
 * Loads the Meta Pixel once and fires the initial PageView.
 */
export function useMetaPixel(pixelId: string) {
  useEffect(() => {
    if (!pixelId || typeof window === 'undefined') return

    if (!window.fbq) {
      const fbq: Window['fbq'] = function (...args: unknown[]) {
        if (fbq!.callMethod) {
          fbq!.callMethod.apply(fbq, args)
        } else {
          fbq!.queue!.push(args)
        }
      } as NonNullable<Window['fbq']>

      fbq.queue = []
      fbq.loaded = true
      fbq.version = '2.0'
      fbq.push = fbq

      window.fbq = fbq
      window._fbq = fbq
    }

    if (!document.getElementById(SCRIPT_ID)) {
      const script = document.createElement('script')
      script.id = SCRIPT_ID
      script.async = true
      script.src = SCRIPT_SRC
      document.head.appendChild(script)
    }

    window.fbq('init', pixelId)
    window.fbq('track', 'PageView')
  }, [pixelId])
}
